import React, {Component} from 'react'
import styled from 'styled-components'
import fire from '../database/firebase'
import {Nav, Navbar, NavbarBrand, NavDropdown, Container} from 'react-bootstrap'
import CountUp from 'react-countup';
import Confetti from 'react-confetti'


const Styles = styled.div `


    // - - NAVBAR - - //

.theNavbar {
    max-width: 95%;
}

.logo {
    font-family: Val;
    color: #99CC63;
    font-size: 30px;
    margin-left: 2%;
    cursor: pointer;
}

.logo:hover {
    color: #724E39;
}

.linkItem {
    max-width: 100%;
    margin-right: 15%;
    }

    // - - NAVBAR LINKS - - //

.navLinks {
    margin-right: 15%;
    color: #FF3C33;
    font-size: 20px;
    font-family: DM Sans;
}

.linkItem {
    margin-right: 50%;
}

.linkItem label {
    color: #99CC63;
    cursor: pointer;
}

.linkItem label:hover {
    color: #724E39;
}

    // - - HEADER - - //

.header {
    text-align: center;
    margin-bottom: 4%;
}

.header h1 {
    font-family: DM Sans;
    color: #724E39;
}

.header h4 {
    margin-left: 7%;
    margin-right: 7%;
    font-family: DM Sans;
    color: #724E39;
    margin-top: 7.5%;
    text-align: justify;
}

.header h5 {
    margin-top: 4.5%;
    font-family: DM Sans;
    font-weight: bold;
}

.header button {
    padding: 1%;
    background-color: #99CC63;
    color: #724E39;
    font-family: DM Sans;
    outline: none;
    border: 2px solid #99CC63;
    border-radius: 8px;
    font-weight: bold;
    margin-top: 1%;
}

    // - - REPORT - - //

.reportRow {
    margin-top: 3%;
    margin-left: 10%;
    margin-right: 10%;
}

.reportRow:after {
    content: "";
    display:table;
    clear: both;
}

.reportCol {
    width: 50%;
    text-align: center;
    float: left;
}

.reportCol1 {
    width: 50%;
    text-align: center;
    float: left;
}

.reportCol h4 {
    text-align: right;
    font-family: DM Sans;
    font-size: 25px;
    margin-top: 2%;
    margin-right: 30%;
}

.reportCol1 h4 {
    margin-top: 3.5%;
    text-align: right;
    margin-right: 30%;
}


    // - - NNUMBER COUNT - - //

.numbers span {
    font-size: 50px;
    font-family: DM Sans;
}

    // - - CONFETTI - - //

.confetti-box {
    width: 100%;
    height: 150%;
}

// - - - - - - - - - - - PHONE DIMENSIONS - - - - - - - - - - - - - //


@media screen and (max-width: 650px) {

            // - - HEADER - - //

    .header {
        margin-bottom: 4%;
    }

    .header h4 {
        font-size: 16px;
        margin-top: 25%;
    }

    .header h5 {
        margin-top: 4.5%;
        font-family: DM Sans;
        font-weight: bold;
        margin-left: 7%;
        margin-right: 7%;
        font-size: 16px;
    }

    .header button { 
        padding: 3%;
        margin-bottom: 10%;
    }

            // - -  REPORT - - //
    
    .reportRow {
        margin-top: 3%;
        margin-left: 3%;
        margin-right: 3%;
    }

    .reportCol h4 {
        text-align: right;
        font-family: DM Sans;
        font-size: 15px;
        margin-top: 10%;
        margin-right: 15%;
    }

    .reportCol1 h4 {
        text-align: right;
        font-family: DM Sans;
        font-size: 15px;
        margin-top: 15%;
        margin-right: 15%;
    }

    .confetti-box {
        height: 125%;
    }

}



`

export default class DailyReport extends Component {
    constructor(props) {
        super(props)
        this.state = {
            completeHPTasks: [],
            completeLPTasks: [],
            relationshipTasks: [],
            generalTasks: [],
            physicalTasks: [],
            spiritualTasks: [],
            mentalTasks: [],
            viewPriority: true,
            viewRegular: true,
            viewRelationships: true,
            viewMental: true,
            viewSpiritual: true,
            viewPhysical: true,
            viewGeneral: true
        }
    }

    componentDidMount = () => {


        
        let bothArr = this.props.highPriorityBucket.concat(this.props.lowPriorityBucket)
        
        if (bothArr.length == 0) {
            this.setState({
                reportNotEmpty: false,
                reportEmpty: true
            })
        } else {
            this.setState({
                reportNotEmpty: true
            })
        }

            // - - HIGH PRIORITY - - //

        let x = this.props.highPriorityBucket.filter((a)=>{if(a.completed==true){return a}});
        if (x.length == 0) {
            this.setState({
                viewPriority: false
            })
        } else {
            this.setState({
                completeHPTasks: x
            })
        }

            // - - LOW PRIORITY - - //

        let y = this.props.lowPriorityBucket.filter((a)=>{if(a.completed==true){return a}});
        if (y.length == 0) {
            this.setState({
                viewRegular: false
            })
        } else {
            this.setState({
                completeLPTasks: y
            })
        }

            // - - RELATIONSHIPS - - //

        let a = bothArr.filter((a)=>{if(a.category.includes("Relationships") && a.completed==true){return a}});
        if (a.length == 0) {
            this.setState({
                viewRelationships: false
            })
        } else {
            this.setState({
                relationshipTasks: a
            })
        }
   

            // - - MENTAL - - //

        let b = bothArr.filter((a)=>{if(a.category.includes("Mental") && a.completed==true){return a}});
        if (b.length == 0) {
            this.setState({
                viewMental: false
            })
        } else {
            this.setState({
                mentalTasks : b
            })
        }


            // - - SPIRITUAL - - //

        let c = bothArr.filter((a)=>{if(a.category.includes("Spiritual") && a.completed==true){return a}});
        if (c.length == 0) {
            this.setState({
                viewSpiritual: false
            })
        } else {
            this.setState({
                spiritualTasks: c
            })
        }

            // - - GENERAL - - //

        let e = bothArr.filter((a)=>{if(a.category.includes("General") && a.completed==true){return a}});
        if (e.length == 0) {
            this.setState({
                viewGeneral: false
            })
        } else {
            this.setState({
                generalTasks: e
            })
        }

            // - - PHYSICAL - - //

        let d = bothArr.filter((a)=>{if(a.category.includes("Physical") && a.completed==true){return a}});
        if (d.length == 0) {
            this.setState({
                viewPhysical: false
            })
        } else {
            this.setState({
                physicalTasks: d
            })
        }

        
    }

    renderReport = () => {
        return(
            <Styles>
                {this.state.viewPriority && 
                <div className='reportRow'>
                    <div className='reportCol1'>
                        <h4>💎 High Priority Tasks: </h4>
                    </div>
                    <div className='reportCol'>
                    <CountUp start={0} end={this.state.completeHPTasks.length} delay={0} duration={0.3}>
                        {({ countUpRef }) => (
                            <div className='numbers'>
                                <b><span ref={countUpRef} /></b>
                            </div>
                        )}
                    </CountUp>
                    </div>
                </div>
                }
                {this.state.viewRegular && 
                <div className='reportRow'>
                    <div className='reportCol1'>
                        <h4>📌 Regular Tasks: </h4>
                    </div>
                    <div className='reportCol'>
                    <CountUp start={0} end={this.state.completeLPTasks.length} delay={0} duration={0.3}>
                        {({ countUpRef }) => (
                            <div className='numbers'>
                                <b><span ref={countUpRef} /></b>
                            </div>
                        )}
                    </CountUp>
                    </div>
                </div>
                }
                {this.state.viewGeneral && 
                <div className='reportRow'>
                    <div className='reportCol1'>
                        <h4>📝 General Tasks:</h4>
                    </div>
                    <div className='reportCol'>
                    <CountUp start={0} end={this.state.generalTasks.length} delay={0} duration={0.3}>
                        {({ countUpRef }) => (
                            <div className='numbers'>
                                <b><span ref={countUpRef} /></b>
                            </div>
                        )}
                    </CountUp>
                    </div>
                </div>
                }
                {this.state.viewRelationships && 
                <div className='reportRow'>
                    <div className='reportCol'>
                        <h4>🤝 Tasks To Better Your Relationships:</h4>
                    </div>
                    <div className='reportCol'>
                    <CountUp start={0} end={this.state.relationshipTasks.length} delay={0} duration={0.3}>
                        {({ countUpRef }) => (
                            <div className='numbers'>
                                <b><span ref={countUpRef} /></b>
                            </div>
                        )}
                    </CountUp>
                    </div>
                </div>
                }
                {this.state.viewMental && 
                <div className='reportRow'>
                    <div className='reportCol'>
                        <h4>🧠 Tasks To Better Your Mental Health:</h4>
                    </div>
                    <div className='reportCol'>
                    <CountUp start={0} end={this.state.mentalTasks.length} delay={0} duration={0.3}>
                        {({ countUpRef }) => (
                            <div className='numbers'>
                                <b><span ref={countUpRef} /></b>
                            </div>
                        )}
                    </CountUp>
                    </div>
                </div>
                }
                {this.state.viewSpiritual &&
                <div className='reportRow'>
                    <div className='reportCol'>
                        <h4>🙏 Tasks To Better Your Spiritual Health:</h4>
                    </div>
                    <div className='reportCol'>
                    <CountUp start={0} end={this.state.spiritualTasks.length} delay={0} duration={0.3}>
                        {({ countUpRef }) => (
                            <div className='numbers'>
                                <b><span ref={countUpRef} /></b>
                            </div>
                        )}
                    </CountUp>
                    </div>
                </div>
                }
                {this.state.viewPhysical && 
                <div className='reportRow'>
                    <div className='reportCol'>
                        <h4>❤️ Tasks To Better Your Physical Health:</h4>
                    </div>
                    <div className='reportCol'>
                    <CountUp start={0} end={this.state.physicalTasks.length} delay={0} duration={0.3}>
                        {({ countUpRef }) => (
                            <div className='numbers'>
                                <b><span ref={countUpRef} /></b>
                            </div>
                        )}
                    </CountUp>
                    </div>
                </div>
                }
            </Styles>
        )
    }

    backToHome = () => {
        window.location.href = "/home"
    }

    render () {
        return(
            <Styles>
                <Confetti
                    className='confetti-box'
                    />
                <div className='header'>
                    <h1>Daily Report</h1>
                    <button
                    onClick={this.backToHome}
                    >Back To Home</button>
                    {this.state.reportNotEmpty && 
                        <div>
                            <h5>🎉 Today you were able to accomplish... </h5>
                            {this.renderReport()}
                        </div>
                    }
                    {this.state.reportEmpty && 
                        <div>
                            <h4>Haven't been able to get anything done? Well don't worry about it. You're worth isn't defined by what you do! 
                                You always have tomorrow to try again 🙂. We'll celebrate <u>you</u> regardless with confetti! 🥳
                            </h4>
                        </div>
                    }
                </div>
            </Styles>
        )
    }
}